/* ELG Redesign 2026-11 – ergänzt die Foxify-Seiten um Kerndaten (Daten aus snippets/elg-daten.liquid). Datei entfernen = Rückbau. */
(() => {
  const quelle = document.getElementById('elg-daten');
  if (!quelle) return;
  let daten;
  try { daten = JSON.parse(quelle.textContent); } catch (e) { return; }

  const kurz = (s) => typeof s === 'string' && s.trim() && s.length <= 28 && !/\n|->/.test(s);
  const einheit = (s) => s.replace(/(\d)\s?(lm|W|mm)\b/g, '$1 $2');

  function lichtfarbe(liste) {
    if (!liste || !liste.length) return null;
    if (liste.includes('Einstellbar')) return 'Lichtfarbe einstellbar';
    const farben = liste.filter((f) => f !== 'Ohne Leuchtmittel');
    if (!farben.length) return null;
    return farben.length === 1 ? farben[0].replace(/\s*\(.*\)/, '') : `${farben.length} Lichtfarben`;
  }

  // Punkt 3: Kerndaten auf Produktkarten
  function karten() {
    document.querySelectorAll('.x-product-card:not([data-elg])').forEach((karte) => {
      karte.dataset.elg = '1';
      const link = karte.querySelector('a[href*="/products/"]');
      const titel = karte.querySelector('.x-product-card__title');
      if (!link || !titel) return;
      const handle = link.getAttribute('href').split('/products/')[1].split(/[?#]/)[0];
      const d = daten.karten[handle];
      if (!d) return;
      const chips = [
        d.l && d.l.length ? d.l.join(' / ') : null,
        kurz(d.lm) ? einheit(d.lm) : null,
        lichtfarbe(d.f),
        d.ip && d.ip.length ? d.ip.join(' / ') : null,
      ].filter(Boolean);
      if (!chips.length) return;
      const box = document.createElement('div');
      box.className = 'elg-chips';
      chips.forEach((text) => {
        const c = document.createElement('span');
        c.className = 'elg-chip';
        c.textContent = text;
        box.appendChild(c);
      });
      titel.insertAdjacentElement('afterend', box);
    });
  }

  // Punkt 4: Kategorie-Kopf mit Bild, Langtext eingeklappt
  function kategorieKopf() {
    const intro = document.querySelector('.elg-category-intro:not([data-elg])');
    if (!intro) return;
    intro.dataset.elg = '1';
    const absaetze = [...intro.querySelectorAll(':scope > p:not(.elg-category-intro__highlight)')];
    if (absaetze.length > 1) {
      intro.classList.add('elg-intro--zu');
      const knopf = document.createElement('button');
      knopf.type = 'button';
      knopf.className = 'elg-intro__mehr';
      knopf.textContent = 'Mehr lesen';
      knopf.addEventListener('click', () => {
        const zu = intro.classList.toggle('elg-intro--zu');
        knopf.textContent = zu ? 'Mehr lesen' : 'Weniger anzeigen';
      });
      absaetze[0].insertAdjacentElement('afterend', knopf);
    }
    const bild = daten.kollektion && daten.kollektion.bild;
    if (bild) {
      const text = document.createElement('div');
      text.className = 'elg-intro__text';
      [...intro.childNodes].forEach((n) => text.appendChild(n));
      const fig = document.createElement('figure');
      fig.className = 'elg-intro__bild';
      const img = document.createElement('img');
      img.src = bild;
      img.alt = daten.kollektion.titel || '';
      img.loading = 'eager';
      fig.appendChild(img);
      intro.append(text, fig);
      intro.classList.add('elg-intro--bild');
    }
  }

  // Punkt 5: Datenleiste unter dem Produkttitel
  function datenleiste() {
    const p = daten.produkt;
    const titel = document.querySelector('.x-product-title:not([data-elg])');
    if (!p || !titel) return;
    titel.dataset.elg = '1';
    // UGR nur zeigen, wenn er bildschirmarbeitsplatztauglich ist ("< 19" oder kleiner)
    const ugrGut = (w) => /^<\s*(\d+)/.test(w.trim()) && Number(w.trim().match(/\d+/)[0]) <= 19;
    const werte = Object.entries(p).filter(([name, w]) => kurz(w) && (name !== 'UGR' || ugrGut(w)));
    if (werte.length < 2) return;
    const liste = document.createElement('ul');
    liste.className = 'elg-datenleiste';
    werte.forEach(([name, wert]) => {
      const li = document.createElement('li');
      const n = document.createElement('span');
      n.textContent = name;
      const w = document.createElement('b');
      w.textContent = name === 'UGR' ? wert : einheit(wert);
      li.append(n, w);
      liste.appendChild(li);
    });
    titel.insertAdjacentElement('afterend', liste);
  }

  function alles() { karten(); kategorieKopf(); datenleiste(); }
  alles();
  // Foxify lädt Produktraster beim Filtern/Sortieren neu – dann erneut ergänzen
  let wartet = false;
  new MutationObserver(() => {
    if (wartet) return;
    wartet = true;
    requestAnimationFrame(() => { wartet = false; alles(); });
  }).observe(document.body, { childList: true, subtree: true });
})();
